module.exports = __webpack_public_path__ + "static/media/unid-grey.44a24da4.svg";